class DesignerEditMenu {

  constructor(config) {
    this.app = config.app;

    document.getElementById("edit_selectnone").addEventListener("click", function () {
      this.app.selectNone();
    }.bind(this));

    document.getElementById("edit_stain").addEventListener("click", function () {
      document.getElementById("stainDialog").showModal();
    });
  }


  
  
  duplicateNode() {
    let sel = this.app.getSelectedNode();

    if (sel && sel.attrs.type != "baseImage" && sel.attrs.group != "Tracks") {
        let cloned = sel.clone();
        this.app.getLayer().add(cloned);

        if (cloned.className === "Image") {
            cloned.filters([
                Konva.Filters.Grayscale,
                Konva.Filters.WhiteToTransparent,
            ]);
            cloned.cache();
            this.app.getLayer().draw();
        }
        this.app.selectNode(cloned);
    }
  }


  handleKeyPress(event) {
    if (event.key === 'Delete') {
        this.handleDeleteItem()
    } else if (event.key === 'Insert') {
        this.app.textMenu.createTextNode({});
    }
  }


  handleDeleteItem() {
    let sel = this.app.getSelectedNode();

    if (sel && sel.attrs.type == "baseImage") {
        showMessage("Notice", "You can no delete the Cribbage board. Please select a new Cribbage board if this is not the one you want.")
    } else if (sel) {
        let selIdx = this.app.getNodeIndex(sel);
        this.app.selectNode(null);
        this.app.deleteNode(sel);

        if (selIdx + 1 > layer.children.length) {
            selIdx = layer.children.length - 1;
            selIdx = this.app.getFirstSelectableNodeIndex();
        }

        if (selIdx != -1) {
            this.app.selectNode(layer.children[selIdx]);
        }
    }
  }



  /*
function centerRectShape(shape) {
  shape.x((layer.getWidth() - shape.getWidth()) / 2);
  shape.y((layer.getHeight() - shape.getHeight()) / 2);
}


function alignTop() {
  let min_y = Infinity;

  if (selectedNode.getClassName() === "Group") {
    // Find the minimum y-coordinate among all selected shapes
    selectedNode.children.forEach(shape => {
      min_y = Math.min(min_y, shape.y());
    });

    // Set the y-coordinate of each shape to the minimum y-coordinate
    selectedNode.children.forEach(shape => {
      shape.y(min_y - shape.getSelfRect().height);
    });
  }
}


function alignBottom() {
  let maxBottom = 0;

  if (selectedNode.getClassName() === "Group") {
    selectedNode.children.forEach(shape => {
      const shapeBottom = shape.y() + shape.height();
      if (shapeBottom > maxBottom) {
        maxBottom = shapeBottom;
      }
    });

    selectedNode.children.forEach(shape => {
      shape.y(maxBottom - shape.height());
    });
  }
}


function alignLeft() {
  let min_x = Infinity;

  if (selectedNode.getClassName() === "Group") {
    // Find the minimum y-coordinate among all selected shapes
    selectedNode.children.forEach(shape => {
      min_x = Math.min(min_x, shape.x());
    });

    // Set the y-coordinate of each shape to the minimum y-coordinate
    selectedNode.children.forEach(shape => {
      shape.x(min_x);
    });
  }
}


function alignRight() {
  let maxRight = 0;

  if (selectedNode.getClassName() === "Group") {
    selectedNode.children.forEach(shape => {
      const shapeRight = shape.x() + shape.width();
      if (shapeRight > maxRight) {
        maxRight = shapeRight;
      }
    });

    selectedNode.children.forEach(shape => {
      shape.y(maxRight - shape.width());
    });
  }
}
  

function centerNodeInBaseImage(obj) {
  if (app.getSelectedNode()) {
    //const parentRect = app.getBaseLayer().getClientRect();
    const parentPos = app.getBaseLayer().getAbsolutePosition();
    const parentSize = app.getBaseLayer().getSize();
    const objRect = app.getSelectedNode().getClientRect();
    const pos = {
      x: (parentPos.x + (parentSize.width / 2)),
      y: (parentPos.y + (parentSize.height / 2)),
    };

    app.getSelectedNode().position(pos);

    layer.batchDraw(); // Use batchDraw for efficiency
  }
}


function centerNodeOffset(node) {
  if (node) {
    node.offset({
      x: node.width() / 2,
      y: node.height() / 2,
    });
  }
}
  */

}



/*
addMultipleEventListener(
  document.getElementById("edit_rotate_left"),
  "mousedown touchstart",
  handleRotateLeft
);
function handleRotateLeft() {
  if (intervalId) {
    clearInterval(intervalId);
  }
  intervalId = setInterval(rotateSelectedLeft, intervalDelay);
}

document.getElementById("edit_rotate_left").addEventListener("click", () => {
  rotateSelectedLeft();
});


addMultipleEventListener(
  document.getElementById("edit_rotate_right"),
  "mousedown touchstart",
  handleRotateRight
);
function handleRotateRight() {
  if (intervalId) {
    clearInterval(intervalId);
  }
  intervalId = setInterval(rotateSelectedRight, intervalDelay);
}

document.getElementById("edit_rotate_right").addEventListener("click", () => {
  rotateSelectedRight();
});


addMultipleEventListener(
  document.getElementById("edit_increase_size"),
  "mousedown touchstart",
  handleScaleUpButton
);
function handleScaleUpButton() {
  if (intervalId) {
    clearInterval(intervalId);
  }
  intervalId = setInterval(scaleUpObject, intervalDelay);
}


addMultipleEventListener(
  document.getElementById("edit_decrease_size"),
  "mousedown touchstart",
  handleScaleDownButton
);
function handleScaleDownButton() {
  if (intervalId) {
    clearInterval(intervalId);
  }
  intervalId = setInterval(scaleDownObject, intervalDelay);
}


function rotateSelectedLeft() {
  rotateObject(app.getSelectedNode(), 1);
}
function rotateSelectedRight() {
  rotateObject(app.getSelectedNode(), -1);
}
function rotateObject(obj, amount = 1) {
  if (obj) {
    obj.rotation(obj.rotation() + amount);
    app.updateProperties();
  }
}


function scaleUpObject() {
  scaleObject(app.getSelectedNode() ?? stage, 0.01);
}
function scaleDownObject() {
  scaleObject(app.getSelectedNode() ?? stage, -0.01);
}
function scaleObject(obj, amount = 0.01) {
  if (obj && canResize(obj)) {
    let newScale = obj.scaleX() + amount;
    obj.scale({ x: newScale, y: newScale });
    updateProperties();
  }
}
*/
